// extracted by mini-css-extract-plugin
module.exports = {"w1wlslkw":"w1wlslkw"};